// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader_data{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgb(181 174 174 / 81%);
    z-index: 9999;
}
.loader{
    left: 45%;
    top: 45%;
    z-index: 1000;
    position: absolute;
    transform: scale(0.5);
    
}
.screenLoader {
    position: fixed;
    height: 100%;
    background: #00000047;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 40vh;
  }`, "",{"version":3,"sources":["webpack://./src/components/Loader/FullPageLoader.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,aAAa;IACb,wCAAwC;IACxC,aAAa;AACjB;AACA;IACI,SAAS;IACT,QAAQ;IACR,aAAa;IACb,kBAAkB;IAClB,qBAAqB;;AAEzB;AACA;IACI,eAAe;IACf,YAAY;IACZ,qBAAqB;IACrB,MAAM;IACN,OAAO;IACP,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,iBAAiB;EACnB","sourcesContent":[".loader_data{\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100vh;\n    background-color: rgb(181 174 174 / 81%);\n    z-index: 9999;\n}\n.loader{\n    left: 45%;\n    top: 45%;\n    z-index: 1000;\n    position: absolute;\n    transform: scale(0.5);\n    \n}\n.screenLoader {\n    position: fixed;\n    height: 100%;\n    background: #00000047;\n    top: 0;\n    left: 0;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    padding-top: 40vh;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
